
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ApiService } from '../../../../core/services/api.service';
import { ServiceName } from '../../../../shared/constants/services.enum';
import { Utils } from '../../../../Utils/utils';
import { LinkMemberQueryRequestModel, UpsertRequestModel } from '../../services/add-business/models/link-member-query-request.model';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { SharedService } from '../../../../shared/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ROLES } from '../../services/add-business/models/roles.model';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-access-request-detail',
  imports: [TranslateModule, ButtonComponent, SkeletonLoaderComponent, ConfirmationModalComponent],
  templateUrl: './access-request-detail.component.html',
  styleUrl: './access-request-detail.component.scss'
})
export class AccessRequestDetailComponent {
  roles: any = ROLES;
  srNumber: any = "";
  lang: string = "en";
  userLoginName: string = "";
  loadingSrDetail: boolean = false;
  userCSN: string = "";
  requestDetail: any;
  technicalErrorMsg: boolean = false;
  showApproveAccessConfirmation: boolean = false;
  approvedUserLoginId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private sharedService: SharedService,
  ) {
    this.lang = this.sharedService.getCurrentLang() || 'en';
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    // this.userCSN = this.sharedService.getCsnAccountId('csn');

    // SR Number in the url
    this.route.params.subscribe(params => {
      if (params['csn']) {
        this.userCSN = params['csn'];
      }
      if (params['sr_no']) {
        this.srNumber = params['sr_no'];
        this.getSRDetail();
      }
    });
  }

  // This method is used to get access request detail
  getSRDetail() {
    this.loadingSrDetail = true;
    const request = new LinkMemberQueryRequestModel();
    request.body.DCMethod = "QUERY";
    request.body.DCLoginName = this.userLoginName;
    request.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    let srData = request.body.DCIncomingHierarchy["ListOfDC Community Portal SR IO"]["DC Community Portal SR"]
    srData['SR Number'] = this.srNumber;
    srData["SR Type"] = ServiceName.USER_MANAGEMENT;
    srData["Sub Type"] = ServiceName.USER_ACCESS;
    srData["CSN"] = this.userCSN;
    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_QUERY_SERVICEREQUEST,
      request
    ).subscribe({
      next: (response: any) => {
        if (response['Error Code'] == null && response["DCSRNumber"] && response.SiebelMessage?.["DC Community Portal SR"]) {
          let srDetail = response.SiebelMessage?.["DC Community Portal SR"];
          this.loadingSrDetail = false;
          this.requestDetail = srDetail;
        }
      },
      error: () => {
        this.loadingSrDetail = false;
        this.technicalErrorMsg = true;
      }
    })
  }

  // This method is used to approve reject request using type and access request
  approveRejectRequest(type: string, accessRequest: any) {
    const request = new UpsertRequestModel();
    request.body.DCMethod = type == 'reject' ? "REJECT" : "APPROVE";
    request.body.DCLoginName = this.userLoginName;
    request.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    request.body.DCIncomingHierarchy.IntObjectName = "DC Community Portal SR Upsert IO";

    let srData = request.body.DCIncomingHierarchy["ListOfDC Community Portal SR Upsert IO"]["DC Community Portal SR"]
    srData['SR Number'] = accessRequest["SR Number"];
    srData["SR Type"] = ServiceName.USER_MANAGEMENT;
    srData["Sub Type"] = ServiceName.USER_ACCESS;
    srData["CSN"] = this.userCSN;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
      request
    ).subscribe({
      next: (response: any) => {
        if (response['Error Code'] == null) {
          if (type == 'approve') {
            this.approvedUserLoginId = this.getRequestedUserLoginId(accessRequest);
            this.showApproveAccessConfirmation = true;
          } else {
            this.sharedService.toastMessage('SUCCESS', 'SUCCESS', 'success');
            this.router.navigate([RoutesPath.MEMBERSHIP.DETAIL, this.userCSN]);
          }
        } else {
          this.sharedService.toastMessage('ERROR', '', 'error', response["Error Message"]);
        }
      }
    });
  }

  private getRequestedUserLoginId(accessRequest: any): string {
    return (
      accessRequest?.['DC Link UserID'] ||
      accessRequest?.['Created By Name'] ||
      accessRequest?.['DC Created User Login Name'] ||
      accessRequest?.['Login Name'] ||
      ''
    ).toString();
  }

  confirmApproveAccessConfirmation() {
    if (!this.approvedUserLoginId) {
      this.showApproveAccessConfirmation = false;
      this.sharedService.toastMessage('Error', 'TECHNICAL_ERROR', 'error');
      return;
    }
    this.showApproveAccessConfirmation = false;
    this.router.navigate([RoutesPath.SERVICE + "/" + RoutesPath.UPDATE_USER, this.userCSN, this.approvedUserLoginId]);
  }
}
